import {of} from 'rxjs';
import {filter, map, mergeMap, throttleTime} from 'rxjs/operators';

import Sentry from '../../config/sentry';
import * as auth from '../reducers/auth';
import * as newAppointmentForm from '../reducers/newAppointmentForm';
import * as patientSignup from '../reducers/patientSignup';

import {appointmentApi} from '../services/appointmentApi';
import {caseApi} from '../services/caseApi';
import {claimApi} from '../services/claimApi';
import {fileApi} from '../services/fileApi';
import {messageApi} from '../services/messageApi';
import {patientApi} from '../services/patientApi';
import {patientStatusApi} from '../services/patientStatusApi';
import {paymentApi} from '../services/paymentApi';
import {payerApi} from '../services/payerApi';
import {sessionApi} from '../services/sessionApi';
import {sessionNoteApi} from '../services/sessionNoteApi';

const cacheClearActions = [
  appointmentApi.util.resetApiState(),
  caseApi.util.resetApiState(),
  messageApi.util.resetApiState(),
  patientApi.util.resetApiState(),
  patientStatusApi.util.resetApiState(),
  sessionApi.util.resetApiState(),
  sessionNoteApi.util.resetApiState(),
  fileApi.util.resetApiState(),
  paymentApi.util.resetApiState(),
  payerApi.util.resetApiState(),
  claimApi.util.resetApiState(),
];

export const loginEpic = (
  action$,
  state$,
  _auth = auth
) => action$.pipe(
  filter(action => action.type === _auth.setCredentials.type),
  map(action => Sentry.setUser({email: action?.payload?.email || null})),
  mergeMap(() => of())
);

export const logoutEpic = (
  action$,
  state$,
  _auth = auth,
  _newAppointmentForm = newAppointmentForm,
  _patientSignup = patientSignup,
) => action$.pipe(
  // filter(() => false),
  filter(action => action.type === _auth.logout.type),
  throttleTime(50),
  mergeMap(() => {
    Sentry.setUser(null);
    return of(...cacheClearActions);
  })
);

export const startImpersonationEpic = (action$, state$, _auth = auth) => action$.pipe(
  filter(action => action.type === _auth.startImpersonation.type),
  mergeMap(() => of(...cacheClearActions))
);

export const stopImpersonationEpic = (action$, state$, _auth = auth) => action$.pipe(
  filter(action => action.type === _auth.stopImpersonation.type),
  map(() => {
    const state = state$?.value?.auth;
    const {
      impersonationEmail: email,
      impersonationUser: user,
      impersonationRefreshToken: refreshToken,
      impersonationToken: accessToken,
      impersonationDeviceToken: deviceToken,
      impersonationDeviceExp: exp,
      impersonationDeviceEmail: deviceEmail,
    } = state;
    const params = {email, user, refreshToken, accessToken, deviceToken, deviceEmail, exp};
    return params;
  }),
  mergeMap(params => of(
    _auth.setDeviceToken(params),
    _auth.clearImpersonation(),
    _auth.logout({email: params.email}),
    _auth.setCredentials(params),
    ...cacheClearActions
  ))
);
